import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteButtonComponent } from './delete-button.component';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    DeleteButtonComponent
  ],
  imports: [
    CommonModule,
    FeahterIconModule,
    NgbTooltipModule
  ],
  exports:[
    DeleteButtonComponent
  ]
})
export class DeleteButtonModule { }
